import { api } from "./api";

const subjectApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSubjects: builder.query({
      query: () => "subjects",
      providesTags: ["subjects"],
    }),
    addSubject: builder.mutation({
      query: (newCategory) => ({
        url: "subject_cerate",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["subjects"],
    }),
    removeSubject: builder.mutation({
      query: (id) => ({
        url: `subject_delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["subjects"],
    }),
    editSubject: builder.mutation({
      query: ({ id, ...editData }) => ({
        url: `/subject_update/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["subjects"],
    }),
  }),
});

export const {
  useGetSubjectsQuery,
  useAddSubjectMutation,
  useRemoveSubjectMutation,
  useEditSubjectMutation,
} = subjectApi;
